import { useEffect, useState } from 'react'
import { Header } from '@/components/ui/header'
import { useSidebarStore } from '@/stores/sidebarStore'

interface Props {
  isWorkspaceLoading: boolean
  isWorkspaceGenerating: boolean
}
export function EditorLoading({ isWorkspaceLoading, isWorkspaceGenerating }: Props) {
  const { isOpen } = useSidebarStore()
  const [message, setMessage] = useState('Preparing Your workspace...')

  useEffect(() => {
    if (!isWorkspaceLoading && !isWorkspaceGenerating) return

    const messages = generateWaitingMessages()

    const intervalId = setInterval(() => {
      setMessage(() => {
        const messageIndex = Math.floor(Math.random() * messages.length)
        return messages[messageIndex]!
      })
    }, 3000)

    return () => clearInterval(intervalId)
  }, [isWorkspaceLoading, isWorkspaceGenerating])

  return (
    <div className="flex h-screen flex-col md:flex-row">
      <Header />
      <div className="flex flex-1 items-center justify-center">
        <div className={`flex flex-col items-center gap-4 ${isOpen ? 'md:ml-64' : 'ml-0'}`}>
          <div className="mx-auto flex w-full max-w-[750px] flex-col items-center justify-center gap-4">
            <div className="border-primary/30 border-t-primary h-12 w-12 animate-spin rounded-full border-4"></div>
            <p
              key={message}
              className="text-dark-primary animate-fade-down animate-duration-500 animate-ease-in text-center text-3xl font-semibold">
              {message}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

function generateWaitingMessages() {
  const allMessages: string[] = [
    '✨ Crafting something special...',
    '🎯 Almost there...',
    '🔍 Getting everything ready...',
  ]

  return allMessages.sort(() => Math.random() - 0.5)
}
